import { useFreeIntent } from "@/components/user-context";

import { LoggedInDefault } from "../logged-in-default";

import { LoggedInJiraFree } from "./free/logged-in-jira-free";

export const LoggedInJira = () => {
    // TO DO: add editions here
    const isFreeEdition = useFreeIntent();

    if (isFreeEdition) {
        return <LoggedInJiraFree />;
    }

    // bxpkit catch-all
    return <LoggedInDefault />;
};
